<script setup>
import { ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import Hero from '@sections/global/Hero.vue'
import GalleryImage from '@components/gallery/GalleryImage.vue'
import Loading from '@components/global/Loading.vue'

const route = useRoute()
const router = useRouter()
const loading = ref(false)
const gallery = ref({})
const requestGallery = ref(null)

const breadcrumbs = ref([
	{
		label: 'Back to Media Galleries',
		to: { name: 'galleries' },
	},
])

function cancelGallery() {
	if (requestGallery.value) requestGallery.value.cancel()
}
function getGallery() {
	loading.value = true
	gallery.value = {}
	cancelGallery()
	let axiosSource = axios.CancelToken.source()
	requestGallery.value = { cancel: axiosSource.cancel }
	axios
		.get(`/api/gallery/${route.params.slug}`, {
			cancelToken: axiosSource.token,
		})
		.then((a) => {
			loading.value = false
			gallery.value = a.data
			breadcrumbs.value.push({
				label: gallery.value.title,
			})
		})
		.catch((e) => {
			if (e?.response?.status === 404) {
				router.push('/media-gallery')
			}
		})
}
getGallery()
</script>

<template>
	<Loading v-if="loading" />
	<template v-else>
		<Hero :title="gallery.title" :breadcrumbs="breadcrumbs" />
		<section class="mb-10">
			<div class="container">
				<div class="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
					<GalleryImage v-for="image in gallery.images" :key="image" :image="image" />
				</div>
			</div>
		</section>
	</template>
</template>
